import ApiService from "@/core/services/api.service";
//import i18nService from "@/core/services/i18n.service.js";
import SiteService from "@/core/services/site.service.js";

const state = {
    errors: null,
    collection: []
};

const getters = {
    bannerCampaignCollection(state) {
        return state.collection;
    },

    getBannerCampaignByID: (state) => (id) => {
        let item = state.collection.find((item) => item.id == id);
        if (!item) {
          item = null;
        }
        return item;
    }
};

const actions = {
    fetchBannerCampaign(context) {
        return new Promise((resolve) => {
            //let appLocale = i18nService.getActiveLanguage();
            ApiService.get(
                "pages/admin/" + SiteService.getActiveSiteId() + "/bannerCampaign"
            ).then(({ data }) => {
              context.commit("fetchBannerCampaign", data);
              resolve();
          });
        }).catch((error) => {
            console.log("Error!: ", error);
        });
    }
};

const mutations = {
    fetchBannerCampaign(state, data) {
      state.collection = data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};